import React from "react";
import SkeletonLoader from "../../../../components/skeleton-loader";
import styles from "./styles.module.scss";

const EquipmentBrandCard = () => {
  return (
    <article className={`${styles.equipmentBrandCard}`}>
      <div className={styles.imageContainer}>
        <SkeletonLoader
          component="div"
          width="100%"
          height="100%"
          borderRadius="0.5rem"
          style={{
            transform: "scale(1, 1)",
          }}
          className={styles.imageSkeleton}
        />
      </div>

      <div className={styles.nameArea}>
        <SkeletonLoader
          variant="text"
          width="62px"
          height="20px"
          borderRadius="0.5rem"
          style={{
            marginBottom: "4px",
          }}
        />
        <SkeletonLoader
          variant="text"
          width="108px"
          height="16px"
          borderRadius="0.5rem"
        />
      </div>
    </article>
  );
};

export default EquipmentBrandCard;
